import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "common-layout",
  style: {"padding-right":"0"}
}
const _hoisted_2 = { class: "console-content-div" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "mymoney-div rounded shadow" }
const _hoisted_5 = { class: "mymoney-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "mymoney-title" }, "我的余额", -1)
const _hoisted_7 = { class: "mymoney-num" }
const _hoisted_8 = {
  class: "row",
  style: {"margin":"0"}
}
const _hoisted_9 = { class: "col-md-6 user-div pt-3 pb-5 user-info-div rounded shadow" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "m-3" }, "用户信息管理", -1)
const _hoisted_11 = { class: "user-info-from" }
const _hoisted_12 = { class: "avatar-upload-wrapper" }
const _hoisted_13 = { class: "col-md-4 skm-div pt-3 pb-5 rounded shadow" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "m-3" }, "收款信息管理", -1)
const _hoisted_15 = { class: "user-info-from" }
const _hoisted_16 = {
  key: 1,
  class: "liu-text-info",
  style: {"line-height":"6rem"}
}
const _hoisted_17 = {
  key: 1,
  class: "liu-text-info ml-3",
  style: {"line-height":"6rem"}
}
const _hoisted_18 = { class: "empower-list-div rounded shadow" }
const _hoisted_19 = { class: "user-empower-header" }
const _hoisted_20 = { style: {"display":"flex","align-items":"center","gap":"0.4rem"} }
const _hoisted_21 = { style: {"max-width":"350px"} }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"4px","font-weight":"600","color":"#fbbf24"} }, "修改规则", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"8px","font-size":"12px","line-height":"1.6"} }, [
  /*#__PURE__*/_createTextVNode(" 1. 每月可免费修改授权的次数有限，超出后需要付费修改"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2. 每个授权总共可免费修改的次数有限，超出后需要付费修改 ")
], -1)
const _hoisted_24 = { style: {"border-top":"1px solid #555","padding-top":"8px"} }
const _hoisted_25 = { style: {"display":"flex","align-items":"center","gap":"4px"} }
const _hoisted_26 = { style: {"color":"#9ca3af"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#6b7280","margin":"0 4px"} }, "→", -1)
const _hoisted_28 = { style: {"color":"#93c5fd"} }
const _hoisted_29 = {
  key: 1,
  style: {"font-size":"0.75rem","color":"#c0c4cc"}
}
const _hoisted_30 = {
  key: 0,
  class: "liu-text-info"
}
const _hoisted_31 = {
  key: 1,
  class: "liu-text-warning"
}
const _hoisted_32 = {
  key: 2,
  class: "liu-text-danger"
}
const _hoisted_33 = { class: "dialog-footer" }
const _hoisted_34 = { class: "dialog-footer" }
const _hoisted_35 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = { class: "money_total_num" }
const _hoisted_38 = { class: "dialog-footer" }
const _hoisted_39 = { class: "ml-4" }
const _hoisted_40 = { class: "mt-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "充值金额", -1)
const _hoisted_42 = { class: "mt-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "支付方式", -1)
const _hoisted_44 = { class: "dialog-footer" }

import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { ref, onMounted, reactive, computed, getCurrentInstance } from 'vue';
import { isNull, getEmpower, EmpowerResponse } from '@/utils/publicMethods';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { ElMessage, } from 'element-plus'
import type { UploadProps } from 'element-plus'
import { Grade } from '@/types/gradeInterface'
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'
import { Platform } from '@element-plus/icons-vue/dist/types';
interface grade_dataIn {
  grade_id: number,
  name: string,
  content: string,
  sell_price: number,
  higher_reward: number,
  isPoss: boolean,
  price_diff: number,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConsoleView',
  setup(__props) {

const baseURL = process.env.VUE_APP_API_BASE_URL;

var labelPosition = 'right'
var user_conf = ref({
  uid: '',
  username: '',
  user_email: '',
  higher_uid: "",
  password: "",
  money: "",
  contact: "",
  avatar: "",
  higher_email: "",
  grade_id: -1,
  grade_name: "",
  grade_content: "",
  sell_price: 0,
  wxQR_code: '',
  zfbQR_code: ''
})
var appConf = ref({
  isRenew: false,
  empower_id: -1,
})
var balanceRechargeDialog = ref({
  isShow: false,
  money: "",
  types: [],
  type: "",
  checkType: { min: 0, max: 0 }
})
var deleteAuth_id = -1;
const getTimePrice = computed(() => {
  const product = time_meal_data.value.price * time_meal_data.value.num;
  return product.toFixed(2);
})

var grade_data = reactive<Grade[]>([]);

const select_option = ref()
var empower_data = ref([
  {
    includes_name: '',
    id: "",
    includes_id: "",
    add_date: '',
    empower_host: '',
    higher_uid: "",
    end_date: ""
  },
])
var updateHost_data = ref({
  empower_id: -1,
  update_host: "",
  paid: 0
})
var updateRemark_data = ref({
  empower_id: -1,
  remark: ""
})
var centerDialog = ref({
  isShow: false,
  title: "info",
  content: "content",
  clickBind: ""
})
var trendsDialog = ref({
  dialogTitle: "",
  dialogVisible: false
})
var addEmpower_dialog = ref({
  dialogTitle: "",
  dialogVisible: false,
  select_option: "",
  time_Option: [],
  user_email: "",
  host: ""
})
var includes_data = ref({
  select_option: "",
  includes_list: [{
    id: "",
    grade_name: "",
    name: "",
    platform: ""
  }
  ]
})
var grade_Option = ref<grade_dataIn[]>([]);
const validateUsername = (rule: any, value: any, callback: any) => {
  const regExp = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
  if (regExp.test(value)) {
    callback(new Error('不能有特殊字符'));
  } else {
    callback();
  }
}
const rules = {
  password: [
    { min: 6, max: 20, message: '长度在6-20位', trigger: ['change', 'blur'] },
  ],
  username: [
    { min: 1, max: 10, message: '长度在1-10位', trigger: ['change', 'blur'] },
    { validator: validateUsername, trigger: ['blur', 'change'] },
  ]
}
const userInfo_form = ref(null)
const openDialog = (title: string, content: string, isShow: boolean, clickBind: string) => {
  if (isShow == false) {
    centerDialog.value.isShow = false
  }
  else {
    centerDialog.value.title = title
    centerDialog.value.content = content
    centerDialog.value.isShow = true
    centerDialog.value.clickBind = clickBind
  }
}
const centerDialogClick = (act: string) => {
  switch (act) {
    case "setUserInfo":
      submitForm('setUserInfo');
      break;
    case 'updateHost':
      submitForm('updateHost');
      break;
    case 'gradeUp':
      submitForm('gradeUp');
      break;
    case 'addEmpower':
      addEmpowerFun('post');
      break;
    case 'renewEmpower':
      renewEmpowerFun();
      break;
    case 'deleteAuth':
      deleteAuth(deleteAuth_id)
      break;
    default:
      break;
  }
}
const updateHostClick = (empower_id: number, update_host: string) => {
  updateHost_data.value.empower_id = empower_id
  updateHost_data.value.update_host = update_host
  updateHost_data.value.paid = 0
  openDialog('消息', '您确认要修改此授权吗', true, 'updateHost')
}

// 解析修改历史JSON字符串
const parseModifyHistory = (history: string) => {
  if (!history) return []
  try {
    return JSON.parse(history)
  } catch {
    return []
  }
}
const updateRemarkClick = (empower_id: number, remark: string) => {
  updateRemark_data.value.empower_id = empower_id
  updateRemark_data.value.remark = remark
  const headers = {
    'token': localStorage.getItem("token")
  }
  axios.post(baseURL + "/userApi/setRemark", updateRemark_data.value, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 401) {
        ElMessage.error('您没有登录')
        setTimeout(() => {
          location.href = "/Login"
        }, 1000);
      }
      else if (res.data.code == 200) {
        ElMessage.success(res.data.msg)
        setTimeout(() => {
          location.reload()
        }, 1000);
      }
      else {
        ElMessage.error(res.data.msg)
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })
}

const renewAuthDialog = (empower_id: number, includes_id: string, version: number) => {
  appConf.value.isRenew = true;
  addEmpower_dialog.value.dialogVisible = true
  includes_data.value.select_option = includes_id;
  appConf.value.empower_id = empower_id;
  getTimeMeal(includes_id, version + "");

}
const renewEmpowerFun = () => {
  openLoading();
  centerDialog.value.isShow = false
  const headers = {
    'token': localStorage.getItem("token")
  }
  // const data = new FormData()
  const data = {
    empower_id: appConf.value.empower_id
    , time_act: time_meal_data.value.meal_id
    , time_num: time_meal_data.value.num
  }
  // data.append("empower_id", appConf.value.empower_id+"")
  // data.append("time_act", time_meal_data.value.meal_id + "")
  // data.append("time_num", time_meal_data.value.num + "")
  axios.post(baseURL + "/userApi/renewSelfEmpower", data, { timeout: 10000, headers: headers })
    .then(async (res) => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        addEmpower_dialog.value.dialogVisible = false
        ElMessage.success(res.data.msg)
        await getUserInfo();
      }
      else {
        ElMessage.error(res.data.msg)
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('续费失败：' + err.message)
    })
}
const getUserInfo = () => {
  openLoading()
  const headers = {
    'token': localStorage.getItem("token")
  }
  axios.get(baseURL + "/userApi/getUserInfo", { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        user_conf.value = res.data.data
        user_conf.value.higher_email = res.data.data.higher_email
        localStorage.setItem("user_conf", JSON.stringify(user_conf.value))
        empower_data.value = res.data.empower_data;
        empower_Conf.value.total = res.data.total_empower
        if (res.data.total_empower < empower_Conf.value.pageSize) {
          empower_Conf.value.disabled = true
        }
      }
      else {
        ElMessage.error(res.data.msg)
        if (res.data.code == 401) {
          ElMessage.error(res.data.msg)
          setTimeout(() => {
            location.href = "/Login"
          }, 500);
        }
      }
    })
    .catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('获取用户信息失败：' + err.message)
    })
}
const submitForm = (act: string) => {
  openLoading()
  centerDialog.value.isShow = false
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  switch (act) {
    case "setUserInfo":
      (userInfo_form as any).value.validate((valid: any) => {
        if (!valid) {
          ElMessage.error('数据格式不符合要求')
        }
        else {
          data.append("act", "setUserInfo");
          if (user_conf.value.password) {
            data.append("password", user_conf.value.password);
          }
          if (user_conf.value.username) {
            data.append("username", user_conf.value.username);
          }
          if (user_conf.value.user_email) {
            data.append("user_email", user_conf.value.user_email);
          }
          if (user_conf.value.contact) {
            data.append("contact", user_conf.value.contact);
          }
          if (user_conf.value.avatar) {
            data.append("avatar", user_conf.value.avatar);
          }
          axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
            .then(res => {
              fullscreenLoading.close()
              if (res.data.code == 401) {
                ElMessage.error('您没有登录')
                setTimeout(() => {
                  location.href = "/Login"
                }, 1000);
              }
              else if (res.data.code == 200) {
                ElMessage.success(res.data.msg)
                setTimeout(() => {
                  location.reload()
                }, 1000);
              }
              else {
                ElMessage.error(res.data.msg)
              }
            })
            .catch(err => {
              fullscreenLoading.close()
              console.log(err)
              ElMessage.error('请求失败：' + err.message)
            })
        }
      })
      break;
    case "updateHost":
      data.append("act", "updateHost");
      if (updateHost_data.value.empower_id && updateHost_data.value.empower_id != -1) {
        data.append("empower_id", String(updateHost_data.value.empower_id));
      }
      if (updateHost_data.value.update_host && updateHost_data.value.update_host != "") {
        data.append("update_host", updateHost_data.value.update_host);
      }
      if (updateHost_data.value.paid == 1) {
        data.append("paid", "1");
      }
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            ElMessage.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            ElMessage.success(res.data.msg)
            setTimeout(() => {
              location.reload()
            }, 1000);
          }
          else if (res.data.code == 4031) {
            // 免费修改次数已用完，弹出确认框展示付费金额
            updateHost_data.value.paid = 1
            const price = (res.data.data && res.data.data.paid_price) ? res.data.data.paid_price : ''
            openDialog('付费修改确认', '免费修改次数已用完，付费修改将扣除 ' + price + ' 元，是否继续？', true, 'updateHost')
          }
          else {
            ElMessage.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          ElMessage.error('请求失败：' + err.message)
        })
      break;
    case 'gradeUp':
      data.append("act", "gradeUp")
      data.append("grade_id", select_option.value)
      axios.post(baseURL + "/userApi/userSet", data, { timeout: 10000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          // openGradeUpDialog(false, "");
          if (res.data.code == 401) {
            ElMessage.error('您没有登录')
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
          }
          else if (res.data.code == 200) {
            ElMessage.success(res.data.msg)
            setTimeout(() => {
              location.reload()
            }, 1000);
          }
          else {
            ElMessage.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          // openGradeUpDialog(false, "");
          console.log(err)
          ElMessage.error('请求失败：' + err.message)
        })
      break;

    default:
      break;
  }
}
const puy_money = () => {
  balanceRechargeDialog.value.isShow = true;
  axios.get(baseURL + "/pay/payType", { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      if (res.data.code == 200) {
        balanceRechargeDialog.value.types = res.data.data.list
      } else {
        ElMessage.error(res.data.msg)
      }
    }).catch(err => {
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })

}

const payTypeChange = (value: any) => {
  for (let i = 0; i < balanceRechargeDialog.value.types.length; i++) {
    const item = balanceRechargeDialog.value.types[i];
    if (item.type == value) {
      value = item
      break;
    }
  }
  balanceRechargeDialog.value.checkType = value;
}
const store = useStore();
const router = useRouter();
const toRecharge = () => {
  const money = parseInt(balanceRechargeDialog.value.money);
  const min = balanceRechargeDialog.value.checkType.min;
  const max = balanceRechargeDialog.value.checkType.max;
  if (money < min || money > max) {
    ElMessage.error('充值金额超出范围：[' + min + ',' + max + ']');
    return;
  }
  openLoading()
  axios.post(baseURL + "/pay/balanceRecharge", {
    name: "余额充值",
    money: balanceRechargeDialog.value.money,
    type: balanceRechargeDialog.value.type
  }, { timeout: 10000, headers: { 'token': localStorage.getItem("token") } })
    .then(res => {
      fullscreenLoading.close()
      if (res.data.code == 200) {
        balanceRechargeDialog.value.isShow = false;
        const data = res.data.data;
        const payType = data.pay_type;
        if (payType === 'alipay_dmf') {
          // 当面付：跳转二维码页面
          const outTradeNo = data.outTradeNo;
          sessionStorage.setItem("outTradeNo", outTradeNo);
          window.open("/alipayDMF", '_blank');
        } else if (payType === 'alipay_web' && data.url) {
          // 支付宝网站支付：返回的是HTML表单，需要写入新窗口自动提交
          const payWin = window.open('', '_blank');
          if (payWin) {
            payWin.document.write(data.url);
            payWin.document.close();
          } else {
            ElMessage.warning('请允许弹出窗口以完成支付');
          }
        } else if (data.url && data.url.startsWith('http')) {
          // 易支付：跳转支付链接
          window.open(data.url, '_blank');
        } else if (data.outTradeNo) {
          // 兼容旧逻辑：无url但有outTradeNo
          sessionStorage.setItem("outTradeNo", data.outTradeNo);
          window.open("/alipayDMF", '_blank');
        } else {
          ElMessage.warning('未获取到支付链接，请联系管理员');
        }
      } else {
        ElMessage.error(res.data.msg)
      }
    }).catch(err => {
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })
}
const withdrawalView = () => {
  location.href = '/Withdrawal'
}
const handleExceed: UploadProps['onExceed'] = (files, uploadFiles) => {
  ElMessage.warning(
    `限制上传一个, 你选择了${files.length} 个文件,`
  )
}
const upload = ref({
  url: baseURL + "/xiaochuFile/uploadImg2",
  header: { 'token': localStorage.getItem('token') },
  wx_data: { 'act': 'uploadWxQR', 'token': localStorage.getItem('token') },
  zfb_data: { 'act': 'uploadZfbQR', 'token': localStorage.getItem('token') },
  avatar_data: { 'act': 'uploadAvatar', 'token': localStorage.getItem('token') },
  wx_code: "",
  zfb_code: '',
})
const beforeAvatarUpload: UploadProps['beforeUpload'] = (rawFile) => {
  if (rawFile.type !== 'image/jpeg' && rawFile.type !== 'image/png' && rawFile.type !== 'image/gif' && rawFile.type !== 'image/jpg') {
    ElMessage.error('只能上传jpeg,png,gif,jp文件')
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('文件大小不能超过 2MB!')
    return false
  }
  return true
}
const handleSuccess = (response: any) => {
  if (response.code == 200) {
    upload.value.wx_code = ""
    upload.value.zfb_code = ""
    ElMessage.success(response.msg)
    if (response.data.includes("avatar")) {
      user_conf.value.avatar = response.data + "?t=" + Date.now()
      ElMessage.success('头像上传并设置成功')
    } else if (response.data.includes("zfb_qr")) {
      user_conf.value.zfbQR_code = response.data + "?t=" + Date.now()
    } else {
      user_conf.value.wxQR_code = response.data + "?t=" + Date.now()
    }
  }
  else {
    ElMessage.error(response.msg)
  }
}
const empower_Conf = ref({
  total: 0,
  pageSize: 10,
  currentPage: 1,
  disabled: false,
})
const sizeChange = (val: number) => {
  empower_Conf.value.pageSize = val
  getEmpower1()
}
const currentChange = (val: number) => {
  empower_Conf.value.currentPage = val
  getEmpower1()
}
const getEmpower1 = async () => {
  const res: EmpowerResponse = await getEmpower(empower_Conf.value.currentPage, empower_Conf.value.pageSize);
  if (res.code == 200) {
    empower_Conf.value.total = res.total_empower
    if (res.data.total_empower < empower_Conf.value.pageSize) {
      empower_Conf.value.disabled = true
    }
    empower_data.value = res.data
  }
}
const addEmpowerFun = (act: string) => {
  if (act == 'dialog') {
    appConf.value.isRenew = false;
    addEmpower_dialog.value.dialogVisible = true;
    time_meal_data.value.time_meal_list = [];
    version_data.value.version_list = [];
    version_data.value.select_option = "";

    openLoading();
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    axios.get(baseURL + "/userApi/getIncludesAll", { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          includes_data.value.includes_list = res.data.data;
        } else {
          ElMessage.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        ElMessage.error('获取插件列表失败：' + err.message);
      });
  } else if (act == 'post') {
    openLoading();
    centerDialog.value.isShow = false;
    const headers = {
      'token': localStorage.getItem("token") || ''
    };

    const data = new FormData();
    data.append("includes_id", includes_data.value.select_option);
    data.append("host", addEmpower_dialog.value.host);
    data.append("email", addEmpower_dialog.value.user_email);
    data.append("time_act", time_meal_data.value.meal_id + "");
    data.append("time_num", time_meal_data.value.num + "");

    // Add version if selected
    if (version_data.value.select_option) {
      data.append("version", version_data.value.select_option);
    }

    axios.post(baseURL + "/userApi/addSelfEmpower", data, { timeout: 10000, headers: headers })
      .then(res => {
        fullscreenLoading.close();
        if (res.data.code == 200) {
          addEmpower_dialog.value.dialogVisible = false;
          ElMessage.success(res.data.msg);
          getUserInfo(); // Refresh user info after successful authorization
        } else {
          ElMessage.error(res.data.msg);
        }
      })
      .catch(err => {
        fullscreenLoading.close();
        console.log(err);
        ElMessage.error('添加授权失败：' + err.message);
      });
  }
}

var time_meal_data = ref({
  select_option: "",
  time_meal_list: [
    {
      meal_id: "",
      min: 1,
      max: 1,
      price: 0,
      time_unit: "",
    }
  ],
  num: 1,
  min: 1,
  max: 1,
  unit: "",
  price: 1,
  meal_id: ""
})
var version_data = ref({
  select_option: "",
  version_list: [] as { version: string; versionName: string }[]
})

// Add method to get plugin versions
const getPluginVersions = (soft_id: string) => {
  // Reset version selection and time meal data
  version_data.value.select_option = "";
  version_data.value.version_list = [];
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  // If no plugin selected, return
  if (!soft_id) return;

  openLoading();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  const data = {
    soft_id: soft_id
  };

  axios.post(baseURL + "/userApi/getSoftVersion", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 200) {
        version_data.value.version_list = res.data.data.list || [];
        // If there's only one version, auto-select it
        if (res.data.data.list && res.data.data.list.length === 1) {
          version_data.value.select_option = res.data.data.list[0].version;
          onVersionChange(res.data.data.list[0].version);
        }
      } else {
        ElMessage.error(res.data.msg || '获取版本信息失败');
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      ElMessage.error('获取版本信息失败：' + err.message);
    });
}

// Add method to handle version change
const onVersionChange = (version: string) => {
  // Reset time meal selection
  time_meal_data.value.select_option = "";
  time_meal_data.value.time_meal_list = [];

  if (version && includes_data.value.select_option) {
    getTimeMeal(includes_data.value.select_option, version);
  }
}
const getTimeMeal = (includes_id: string, version?: string) => {
  openLoading();
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token") || ''
  };

  data.append("includes_id", includes_id);
  data.append("act", "getTimeMeal");

  // Add version if provided
  if (version) {
    data.append("version", version);
  }

  axios.post(baseURL + "/userApi/getInfo", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close();
      if (res.data.code == 401) {
        ElMessage.error('您没有登录');
        setTimeout(() => {
          location.href = "/Login";
        }, 1000);
      } else if (res.data.code == 200) {
        time_meal_data.value.time_meal_list = res.data.data;
      } else {
        ElMessage.error(res.data.msg);
      }
    })
    .catch(err => {
      fullscreenLoading.close();
      console.log(err);
      ElMessage.error('请求失败：' + err.message);
    });
}
const deleteAuthDialog = (empower_id: number) => {
  deleteAuth_id = empower_id
  openDialog('消息', '您确定要删除此授权吗？此操作不可撤销', true, 'deleteAuth')
}
const deleteAuth = (empower_id: number) => {
  openLoading()
  const data = new FormData();
  const headers = {
    'token': localStorage.getItem("token")
  }
  data.append("id", empower_id + "")
  axios.post(baseURL + "/userApi/deleteAuth", data, { timeout: 10000, headers: headers })
    .then(res => {
      fullscreenLoading.close()
      centerDialog.value.isShow = false
      if (res.data.code == 401) {
        ElMessage.error('您没有登录')
        setTimeout(() => {
          location.href = "/Login"
        }, 1000);
      }
      else if (res.data.code == 200) {
        ElMessage.success(res.data.msg);
        setTimeout(() => {
          getUserInfo()
        }, 200);
      }
      else {
        ElMessage.error(res.data.msg)
      }
    })
    .catch(err => {
      centerDialog.value.isShow = false
      fullscreenLoading.close()
      console.log(err)
      ElMessage.error('请求失败：' + err.message)
    })
}
const setTimeMeal = (select_option: string) => {
  var element = time_meal_data.value.time_meal_list.filter(item => item.meal_id == select_option);
  time_meal_data.value.num = 1
  time_meal_data.value.min = element[0].min
  time_meal_data.value.max = element[0].max
  time_meal_data.value.unit = element[0].time_unit
  time_meal_data.value.price = element[0].price
  time_meal_data.value.meal_id = element[0].meal_id
}
//计算结束时间还有多久
const getEndDateColor = (end_date: string) => {
  var endDate = new Date(end_date);
  if (endDate.getTime() < new Date().getTime()) {
    return 3;
  }
  if (endDate.getTime() < new Date().getTime() + 1000 * 60 * 60 * 24 * 3) {
    return 2;
  }
  return 1;
}

onMounted(async () => {
  const globalProperties = getCurrentInstance().appContext.config.globalProperties;
  window.ResizeObserver = globalProperties.$customResizeObserver;
  await getUserInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_User = _resolveComponent("User")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { style: {"height":"100vh","width":"100vw"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, { style: {"width":"fit-content"} }, {
          default: _withCtx(() => [
            _createVNode(UserHead)
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { style: {"padding":"0"} }, {
              default: _withCtx(() => [
                _createVNode(HeadTop)
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, { style: {"padding":"0","overflow":"auto","background-color":"rgb(242 242 242) !important"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (puy_money()), ["prevent"])),
                          class: "mymoney-puy"
                        }, "在线充值"),
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (withdrawalView()), ["prevent"])),
                          class: "mymoney-puy mr-3"
                        }, "提现")
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(user_conf).money) + "元", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_el_form, {
                          "label-position": _unref(labelPosition),
                          "label-width": "auto",
                          rules: rules,
                          ref_key: "userInfo_form",
                          ref: userInfo_form,
                          model: _unref(user_conf),
                          style: {"max-width":"90%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { label: "头像" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                  (_unref(user_conf).avatar)
                                    ? (_openBlock(), _createBlock(_component_el_avatar, {
                                        key: 0,
                                        size: 60,
                                        src: _unref(user_conf).avatar
                                      }, null, 8, ["src"]))
                                    : (_openBlock(), _createBlock(_component_el_avatar, {
                                        key: 1,
                                        size: 60,
                                        style: {"background":"#409EFF"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 30 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_User)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })),
                                  _createVNode(_component_el_upload, {
                                    "show-file-list": false,
                                    class: "avatar-uploader-btn",
                                    action: upload.value.url,
                                    headers: upload.value.header,
                                    data: upload.value.avatar_data,
                                    accept: "image/*",
                                    "on-success": handleSuccess,
                                    "before-upload": beforeAvatarUpload
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        size: "small",
                                        type: "primary",
                                        class: "ml-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("上传头像")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["action", "headers", "data"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "用户编号" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  disabled: "",
                                  modelValue: _unref(user_conf).uid,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(user_conf).uid) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "用户名",
                              prop: "username"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(user_conf).username,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(user_conf).username) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "联系方式" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _unref(user_conf).contact,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(user_conf).contact) = $event)),
                                  placeholder: "比如：微信号yishousup"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "我的上级",
                              prop: "higher_uid"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  disabled: "",
                                  modelValue: _unref(user_conf).higher_uid,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(user_conf).higher_uid) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "绑定邮箱" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  disabled: "",
                                  modelValue: _unref(user_conf).user_email,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(user_conf).user_email) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "登录密码",
                              prop: "password"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  placeholder: "***********",
                                  modelValue: _unref(user_conf).password,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(user_conf).password) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { class: "form-el-btn" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (openDialog('消息', '您确认要修改用户信息吗', true, 'setUserInfo')))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 保存 ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["label-position", "model"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { label: "微信" }, {
                              default: _withCtx(() => [
                                (!_unref(isNull)(_unref(user_conf).wxQR_code))
                                  ? (_openBlock(), _createBlock(_component_el_image, {
                                      key: 0,
                                      "preview-src-list": [_unref(user_conf).wxQR_code],
                                      src: _unref(user_conf).wxQR_code,
                                      "zoom-rate": 1.2,
                                      "max-scale": 7,
                                      "min-scale": 0.2,
                                      "initial-index": 4,
                                      fit: "cover",
                                      class: "liu-el-image"
                                    }, null, 8, ["preview-src-list", "src"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_upload, {
                                  "show-file-list": false,
                                  class: "avatar-uploader",
                                  action: upload.value.url,
                                  headers: upload.value.header,
                                  drag: _unref(isNull)(_unref(user_conf).wxQR_code),
                                  data: upload.value.wx_data,
                                  multiple: "false",
                                  accept: "image/*",
                                  limit: 1,
                                  "on-exceed": handleExceed,
                                  "on-success": handleSuccess,
                                  "before-upload": beforeAvatarUpload
                                }, {
                                  default: _withCtx(() => [
                                    (_unref(isNull)(_unref(user_conf).wxQR_code))
                                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Plus)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_16, "点击更改"))
                                  ]),
                                  _: 1
                                }, 8, ["action", "headers", "drag", "data"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "支付宝" }, {
                              default: _withCtx(() => [
                                (!_unref(isNull)(_unref(user_conf).zfbQR_code))
                                  ? (_openBlock(), _createBlock(_component_el_image, {
                                      key: 0,
                                      "preview-src-list": [_unref(user_conf).zfbQR_code],
                                      src: _unref(user_conf).zfbQR_code,
                                      "zoom-rate": 1.2,
                                      "max-scale": 7,
                                      "min-scale": 0.2,
                                      "initial-index": 4,
                                      fit: "cover",
                                      class: "liu-el-image"
                                    }, null, 8, ["preview-src-list", "src"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_upload, {
                                  "show-file-list": false,
                                  modelValue: upload.value.zfb_code,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((upload.value.zfb_code) = $event)),
                                  class: "avatar-uploader",
                                  action: upload.value.url,
                                  headers: upload.value.header,
                                  drag: _unref(isNull)(_unref(user_conf).zfbQR_code),
                                  data: upload.value.zfb_data,
                                  multiple: "false",
                                  accept: "image/*",
                                  limit: 1,
                                  "on-exceed": handleExceed,
                                  "on-success": handleSuccess,
                                  "before-upload": beforeAvatarUpload
                                }, {
                                  default: _withCtx(() => [
                                    (_unref(isNull)(_unref(user_conf).zfbQR_code))
                                      ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Plus)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_17, "点击更改"))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "action", "headers", "drag", "data"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        class: "ml-5 mt-1 mb-3",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (addEmpowerFun('dialog')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("添加授权")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_el_table, {
                      data: _unref(empower_data),
                      class: "empower_data"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "includes_name",
                          label: "插件名"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "version_name",
                          label: "插件版本"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "includes_id",
                          label: "插件id",
                          width: "100"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "add_date",
                          label: "添加时间"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "授权字段",
                          width: "180"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_input, {
                              modelValue: scope.row.empower_host,
                              "onUpdate:modelValue": ($event: any) => ((scope.row.empower_host) = $event),
                              onChange: ($event: any) => (updateHostClick(scope.row.empower_id, scope.row.empower_host)),
                              placeholder: "请输入内容"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "修改记录",
                          width: "200"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_el_tag, {
                                size: "small",
                                type: scope.row.modify_count >= 10 ? 'danger' : 'info'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.modify_count || 0) + "/10 ", 1)
                                ]),
                                _: 2
                              }, 1032, ["type"]),
                              (scope.row.modify_history)
                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                    key: 0,
                                    placement: "left",
                                    width: "400"
                                  }, {
                                    content: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_21, [
                                        _hoisted_22,
                                        _hoisted_23,
                                        _createElementVNode("div", _hoisted_24, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseModifyHistory(scope.row.modify_history), (item, idx) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: idx,
                                              style: {"font-size":"12px","line-height":"1.8","color":"#d1d5db"}
                                            }, [
                                              _createElementVNode("span", _hoisted_25, [
                                                _createElementVNode("span", null, _toDisplayString(item.time), 1),
                                                _createVNode(_component_el_tag, {
                                                  size: "small",
                                                  type: item.is_paid == 1 ? 'success' : 'info',
                                                  style: {"height":"18px","line-height":"18px","font-size":"11px","padding":"0 4px"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.is_paid == 1 ? '付费' : '免费'), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["type"])
                                              ]),
                                              _createElementVNode("span", _hoisted_26, _toDisplayString(item.old_host), 1),
                                              _hoisted_27,
                                              _createElementVNode("span", _hoisted_28, _toDisplayString(item.new_host), 1)
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        size: "small",
                                        text: "",
                                        type: "primary",
                                        style: {"padding":"0"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" 查看记录 ")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createElementBlock("span", _hoisted_29, "暂无记录"))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "备注",
                          width: "180"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_input, {
                              modelValue: scope.row.remark,
                              "onUpdate:modelValue": ($event: any) => ((scope.row.remark) = $event),
                              onChange: ($event: any) => (updateRemarkClick(scope.row.empower_id, scope.row.remark)),
                              placeholder: "请输入内容"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "add_uid",
                          label: "授权者id",
                          width: "150"
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "end_date",
                          label: "到期时间"
                        }, {
                          default: _withCtx((scope) => [
                            (getEndDateColor(scope.row.end_date) == 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(scope.row.end_date), 1))
                              : (getEndDateColor(scope.row.end_date) == 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(scope.row.end_date) + "(即将到期)", 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(scope.row.end_date) + "(已到期)", 1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, { label: "操作" }, {
                          default: _withCtx((scope) => [
                            (getEndDateColor(scope.row.end_date) === 3 || scope.row.is_free == 1)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  onClick: ($event: any) => (deleteAuthDialog(scope.row.empower_id)),
                                  type: "danger"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("删除")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_button, {
                              onClick: ($event: any) => (renewAuthDialog(scope.row.empower_id, scope.row.includes_id, scope.row.version)),
                              type: "success"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("续费")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    _createVNode(_component_el_pagination, {
                      class: "pagination",
                      "current-page": empower_Conf.value.currentPage,
                      "onUpdate:currentPage": _cache[11] || (_cache[11] = ($event: any) => ((empower_Conf.value.currentPage) = $event)),
                      "page-size": empower_Conf.value.pageSize,
                      "onUpdate:pageSize": _cache[12] || (_cache[12] = ($event: any) => ((empower_Conf.value.pageSize) = $event)),
                      "page-sizes": [10, 25, 50],
                      disabled: empower_Conf.value.disabled,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: empower_Conf.value.total,
                      onSizeChange: sizeChange,
                      onCurrentChange: currentChange
                    }, null, 8, ["current-page", "page-size", "disabled", "total"])
                  ]),
                  _createVNode(_component_el_dialog, {
                    "close-on-click-modal": false,
                    modelValue: _unref(centerDialog).isShow,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(centerDialog).isShow) = $event)),
                    title: _unref(centerDialog).title,
                    width: "500",
                    "align-center": ""
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_el_button, {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(centerDialog).isShow = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("关闭")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (centerDialogClick(_unref(centerDialog).clickBind)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 确认 ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(centerDialog).content), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "title"]),
                  _createVNode(_component_el_dialog, {
                    "close-on-click-modal": false,
                    modelValue: _unref(trendsDialog).dialogVisible,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(trendsDialog).dialogVisible) = $event)),
                    title: "选择等级",
                    style: {"width":"fit-content"},
                    "align-center": ""
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_el_button, {
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(trendsDialog).dialogVisible = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("关闭")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (centerDialogClick('gradeUp')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 确认升级 ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_form, {
                        "label-position": "top",
                        style: {"width":"40rem"},
                        "label-width": "auto"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "升级等级" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: select_option.value,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((select_option).value = $event)),
                                placeholder: "请选择需要升级的等级"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(grade_Option), (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.grade_id,
                                      label: item.name + '---' + item.price_diff + '元',
                                      value: item.grade_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128)),
                                  (_unref(grade_Option).length == 0)
                                    ? (_openBlock(), _createBlock(_component_el_option, {
                                        key: 0,
                                        label: "您已经是最高等级了"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_dialog, {
                    "close-on-click-modal": false,
                    modelValue: _unref(addEmpower_dialog).dialogVisible,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(addEmpower_dialog).dialogVisible) = $event)),
                    title: "添加授权",
                    "align-center": ""
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_el_button, {
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_unref(addEmpower_dialog).dialogVisible = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("关闭")
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (openDialog('消息', '您确定要添加此授权吗？您需要支付' + getTimePrice.value + '元', true, 'addEmpower')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 添加授权 ")
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, !_unref(appConf).isRenew]
                        ]),
                        _withDirectives(_createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (openDialog('消息', '您确定要续费此授权吗？您需要支付' + getTimePrice.value + '元', true, 'renewEmpower')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 添加授权 ")
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _unref(appConf).isRenew]
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_form, {
                        "label-position": "top",
                        style: {"width":"30rem","margin":"2rem auto"},
                        "label-width": "auto"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_el_form_item, { label: "授权插件" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(includes_data).select_option,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(includes_data).select_option) = $event)),
                                onChange: getPluginVersions,
                                placeholder: "请选择插件"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(includes_data).includes_list, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.id + '---' + item.platform + '---' + item.name,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128)),
                                  (_unref(includes_data).includes_list.length == 0)
                                    ? (_openBlock(), _createBlock(_component_el_option, {
                                        key: 0,
                                        disabled: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("--暂无插件/您不是任何插件的代理--")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, !_unref(appConf).isRenew]
                          ]),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "功能版本" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(version_data).select_option,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(version_data).select_option) = $event)),
                                onChange: onVersionChange,
                                placeholder: "请选择功能版本",
                                disabled: _unref(version_data).version_list.length === 0
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(version_data).version_list, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.version,
                                      label: item.version + '--' + item.versionName,
                                      value: item.version
                                    }, null, 8, ["label", "value"]))
                                  }), 128)),
                                  (_unref(version_data).version_list.length === 0 && _unref(includes_data).select_option)
                                    ? (_openBlock(), _createBlock(_component_el_option, {
                                        key: 0,
                                        disabled: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("--该插件无版本信息--")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, !_unref(appConf).isRenew]
                          ]),
                          _createVNode(_component_el_form_item, { label: "授权时长单位" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(time_meal_data).select_option,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(time_meal_data).select_option) = $event)),
                                onChange: _cache[23] || (_cache[23] = ($event: any) => (setTimeMeal(_unref(time_meal_data).select_option))),
                                placeholder: "请选择时长单位",
                                disabled: _unref(time_meal_data).time_meal_list.length === 0
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(time_meal_data).time_meal_list, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.meal_id,
                                      label: item.time_unit + '---每' + item.time_unit + ' ' + item.price + '元',
                                      value: item.meal_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "授权时长" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                modelValue: _unref(time_meal_data).num,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(time_meal_data).num) = $event)),
                                min: _unref(time_meal_data).min,
                                max: _unref(time_meal_data).max
                              }, null, 8, ["modelValue", "min", "max"]),
                              (_unref(time_meal_data).unit != '')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CloseBold)
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("span", null, _toDisplayString(_unref(time_meal_data).unit), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "绑定邮箱" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(addEmpower_dialog).user_email,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(addEmpower_dialog).user_email) = $event)),
                                placeholder: "若是普通用户则填写当前绑定邮箱",
                                title: "若是普通用户则只能为自己授权"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, !_unref(appConf).isRenew]
                          ]),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "授权字段(域名/ip等)" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(addEmpower_dialog).host,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(addEmpower_dialog).host) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, !_unref(appConf).isRenew]
                          ]),
                          _createVNode(_component_el_form_item),
                          (_unref(time_meal_data).unit != '')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                label: "总计:"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("span", _hoisted_37, _toDisplayString(getTimePrice.value), 1),
                                    _createTextVNode("元 ")
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _unref(balanceRechargeDialog).isShow,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(balanceRechargeDialog).isShow) = $event)),
                    title: "充值",
                    width: "500",
                    "align-center": ""
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_el_button, {
                          onClick: _cache[33] || (_cache[33] = ($event: any) => (_unref(balanceRechargeDialog).isShow = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("取消")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[34] || (_cache[34] = ($event: any) => (toRecharge()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 确定 ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createVNode(_component_el_input, {
                            min: _unref(balanceRechargeDialog).checkType.min,
                            max: _unref(balanceRechargeDialog).checkType.max,
                            modelValue: _unref(balanceRechargeDialog).money,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(balanceRechargeDialog).money) = $event)),
                            style: {"width":"80%"},
                            class: "ml-3",
                            size: "large",
                            placeholder: '单笔充值范围:' + _unref(balanceRechargeDialog).checkType.min + '--' + _unref(balanceRechargeDialog).checkType.max,
                            type: "number"
                          }, null, 8, ["min", "max", "modelValue", "placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createVNode(_component_el_select, {
                            modelValue: _unref(balanceRechargeDialog).type,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(balanceRechargeDialog).type) = $event)),
                            placeholder: "支付方式",
                            size: "large",
                            style: {"width":"80%"},
                            class: "ml-3",
                            onChange: payTypeChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(balanceRechargeDialog).types, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.type,
                                  label: item.name + '(手续费' + item.fee + ')',
                                  value: item.type
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})